<div style="width: 100%; display: flex; justify-content: space-between; align-items: center">
  <h2 mat-dialog-title style="margin-bottom: 0">{{'CREATE_TASK' | translate}}</h2>
  <button mat-icon-button (click)="onNoClick()" style="margin-right: 12px"><mat-icon>close</mat-icon></button>
</div>

<mat-dialog-content style="min-width: 280px; padding-left: 0; padding-right: 0; padding-top: 0">

  <div>
    <mat-stepper
      class="example-stepper"
      [orientation]="(stepperOrientation | async)!" #stepper [ngClass]="{ 'mat-stepper-disabled': isInitialLoading }">

      <mat-step [stepControl]="firstFormGroup" label="{{'INFORMATION' | translate}}">
        <p *ngIf="isInitialLoading">{{'DATA_LOADING' | translate}}</p>
        <form [formGroup]="firstFormGroup" *ngIf="!isInitialLoading">
          <p class="upload-title">{{'INFORMATION' | translate}}</p>
          <div class="wf-data-div">
            <div class="input-box">
              <span class="input-field-label">{{'SUBJECT' | translate}}*</span>
              <mat-form-field class="field-width">
                <input matInput formControlName="subjectCtrl"
                       required (input)="onSubjectChange($event)">
                <mat-error *ngIf="firstFormGroup.get('subjectCtrl')?.hasError('required')">
                  {{'MANDATORY_FIELD' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="input-box">
              <span class="input-field-label">{{'PARTNER' | translate}}</span>
              <mat-form-field class="field-width">
                <mat-icon matIconPrefix>search</mat-icon>
                <input #inputPartner
                       type="text"
                       placeholder="{{'SEARCHING_FOR_PARTNER' | translate}}"
                       matInput
                       [formControl]="partnerControl"
                       [matAutocomplete]="autoPartner" (input)="onSearchPartner(inputPartner.value)">
                <mat-autocomplete #autoPartner="matAutocomplete" [displayWith]="displayPartnerFn" requireSelection="true"
                                  (optionSelected)="setPartner($event.option.value)">
                  <mat-option *ngIf="partnerNotFound" disabled="true">{{'NO_RESULTS' | translate}}</mat-option>
                  <mat-option *ngFor="let partner of filteredPartnerOptions | async" [value]="partner">
                    {{partner.partnerFullName}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="input-box" *ngIf="priorityList.length>0 && !isInitialLoading">
              <span class="input-field-label">{{'PRIORITY' | translate}}</span>
              <mat-form-field class="field-width">
                <mat-select (selectionChange)="setPriority($event.value)" placeholder="{{'NOT_SELECTED' | translate}}">
                  <mat-option [value]="null">{{'NOT_SELECTED' | translate}}</mat-option>
                  <mat-option *ngFor="let item of priorityList" [value]="item">{{item.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="input-box">
              <span class="input-field-label">{{'START_DATE' | translate}}</span>
              <mat-form-field class="field-width">
                <input matInput
                       [matDatepicker]="pickerStartDate"
                       placeholder="YYYY. MM. DD."
                       formControlName="startDateCtrl"
                       [min]="minDate">
                <mat-datepicker-toggle matIconSuffix [for]="pickerStartDate" class="icon-button"></mat-datepicker-toggle>
                <mat-datepicker touchUi="true" #pickerStartDate></mat-datepicker>
                <mat-error *ngIf="firstFormGroup.get('startDateCtrl')?.hasError('min')">
                  {{'START_DATE_TOO_EARLY' | translate}}
                </mat-error>
                <mat-error *ngIf="firstFormGroup.get('startDateCtrl')?.hasError('max')">
                  {{'START_DATE_IS_LATER_THAN_DEADLINE' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="input-box">
              <span class="input-field-label">{{'DEADLINE_DATE' | translate}}</span>
              <mat-form-field class="field-width">
                <input matInput
                       [matDatepicker]="pickerDeadline"
                       placeholder="YYYY. MM. DD."
                       formControlName="deadlineCtrl"
                       [min]="minDeadlineDate">
                <mat-datepicker-toggle matIconSuffix [for]="pickerDeadline" class="icon-button"></mat-datepicker-toggle>
                <mat-datepicker touchUi="true" #pickerDeadline></mat-datepicker>
                <mat-error *ngIf="firstFormGroup.get('deadlineCtrl')?.hasError('min')">
                  {{'DEADLINE_TOO_EARLY' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="input-box">
              <span class="input-field-label">{{'DEADLINE_TIME' | translate}}</span>
              <mat-form-field class="field-width">
                <input
                  matInput
                  type="time"
                  placeholder="HH:MM"
                  formControlName="deadlineTimeCtrl"
                  (change)="onTimeChange($event)">
                <!-- <mat-icon matIconSuffix style="color: rgb(0 0 0 / 38%)">access_time</mat-icon> -->
              </mat-form-field>
            </div>

            <div class="input-box">
              <span class="input-field-label">{{'NEEDS_APPROVAL_FROM_CREATOR' | translate}}</span>
<!--              <mat-checkbox class="checkbox-margin checkbox-label" formControlName="creatorApprovalCtrl">-->
<!--                {{creatorApproved() ? ('YES' | translate) : ('NO' | translate) }}-->
<!--              </mat-checkbox>-->
              <mat-form-field class="field-width">
                <mat-select (selectionChange)="setCreatorApproval($event.value)" placeholder="{{'NOT_SELECTED' | translate}}">
                  <mat-option [value]="null">{{'NOT_SELECTED' | translate}}</mat-option>
                  <mat-option [value]="true">{{'YES' | translate}}</mat-option>
                  <mat-option [value]="false">{{'NO' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="input-box" *ngIf="allowedExecutorTypes.length>0 && !isInitialLoading">
              <span class="input-field-label">{{'EXECUTOR_TYPE' | translate}}*</span>
              <mat-form-field class="field-width">
                <mat-select formControlName="executorTypeCtrl"
                            (selectionChange)="setExecutorType($event.value)"
                            required>
                  <mat-option *ngFor="let item of allowedExecutorTypes" [value]="item">{{item.name}}</mat-option>
                </mat-select>
                <mat-error *ngIf="firstFormGroup.get('executorTypeCtrl')?.hasError('required')">
                  {{'MANDATORY_FIELD' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div style="width: 100%; display: flex; flex-direction: row; align-items: center; justify-content: space-between">
            <p class="desc-title">{{'DESCRIPTION' | translate}}</p>
            <button mat-icon-button (click)="showEditor()" [disabled]="isEditor"><mat-icon>edit</mat-icon></button>
          </div>
          <mat-form-field style="width: 100%" *ngIf="!isEditor">
            <textarea matInput formControlName="descriptionCtrl"></textarea>
          </mat-form-field>
          <quill-editor class="content-editor" formControlName="descriptionCtrl" style="width: 100%; margin-bottom: 22px" *ngIf="isEditor"></quill-editor>
        </form>
      </mat-step>

      <mat-step [stepControl]="secondFormGroup" label="{{'RECIPIENTS' | translate}}"
                [completed]="recipientUserList.length > 0 || recipientOrganizationList.length > 0">
        <ng-template matStepContent>
          <form [formGroup]="secondFormGroup">
            <div style="display: flex; flex-direction: column">

              <div style="display: flex; flex-flow: row wrap; align-items: center; column-gap: 24px">
                <div class="input-box">
                  <span class="input-field-label">{{'USER' | translate}}</span>
                  <mat-form-field class="field-width field-bottom" subscriptSizing="dynamic">
                    <mat-icon matIconPrefix>search</mat-icon>
                    <input #inputRecipientUser
                           type="text"
                           placeholder="{{'SEARCHING_FOR_PERSON' | translate}}"
                           matInput
                           (input)="onSearchUser(inputRecipientUser.value)"
                           [formControl]="recipientUserControl"
                           [matAutocomplete]="autoRecipientUser">
                    <mat-autocomplete #autoRecipientUser="matAutocomplete"
                                      [displayWith]="displayRecipientUserFn"
                                      requireSelection="true"
                                      (optionSelected)="selectRecipientUser($event.option.value)">
                      <mat-option *ngIf="recipientUserNotFound" disabled="true">{{'NO_RESULTS' | translate}}</mat-option>
                      <mat-option *ngFor="let user of filteredRecipientUserOptions | async" [value]="user">
                        {{user.userName}} ({{user.orgName}})
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div class="mb-22">
                  <button mat-stroked-button [disabled]="!selectedRecipientUser"
                          (click)="addRecipientUser()">
                    {{'ADD' | translate}}
                  </button>
                </div>
              </div>

              <div style="display: flex; flex-flow: row wrap; align-items: center; column-gap: 24px">
                <div class="input-box">
                  <span class="input-field-label">{{'ORGANIZATIONAL_UNIT' | translate}}</span>
                  <mat-form-field class="field-width field-bottom" subscriptSizing="dynamic">
                    <mat-icon matIconPrefix>search</mat-icon>
                    <input #inputRecipientOrganization
                           type="text"
                           placeholder="{{'SEARCHING_FOR_ORGANIZATION' | translate}}"
                           matInput
                           (input)="onSearchOrganization(inputRecipientOrganization.value)"
                           [formControl]="recipientOrganizationControl"
                           [matAutocomplete]="autoRecipientOrganization">
                    <mat-autocomplete #autoRecipientOrganization="matAutocomplete"
                                      [displayWith]="displayRecipientOrganizationFn"
                                      requireSelection="true"
                                      (optionSelected)="selectRecipientOrganization($event.option.value)">
                      <mat-option *ngIf="recipientOrganizationNotFound" disabled="true">{{'NO_RESULTS' | translate}}</mat-option>
                      <mat-option *ngFor="let organization of filteredRecipientOrganizationOptions | async" [value]="organization">
                        {{organization.name}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div class="mb-22">
                  <button mat-stroked-button [disabled]="!selectedRecipientOrganization"
                          (click)="addRecipientOrganization()">
                    {{'ADD' | translate}}
                  </button>
                </div>
              </div>
            </div>
            <mat-expansion-panel style="border: none; box-shadow: none; margin-bottom: 12px" togglePosition="before" [expanded]="recipientUserList.length > 0" [disabled]="recipientUserList.length === 0">
              <mat-expansion-panel-header style="padding-left: 2px; padding-right: 0" expandedHeight="48px" collapsedHeight="48px">
                <mat-panel-title>{{'RECIPIENT_USERS' | translate}} ({{recipientUserList.length}})</mat-panel-title>
              </mat-expansion-panel-header>
              <mat-list style="padding: 0">
                <div *ngFor="let user of recipientUserList; let i = index">
                  <mat-list-item>
                    <div matListItemTitle>{{user.userName}}</div>
                    <div matListItemLine>{{user.orgName}}</div>
                    <div matListItemMeta>
                      <button mat-icon-button (click)="removeRecipientUser(i)" class="delete-button" style="margin-top: 8px">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </mat-list-item>
                  <mat-divider class="divider-position"></mat-divider>
                </div>
              </mat-list>
            </mat-expansion-panel>

            <mat-expansion-panel style="border: none; box-shadow: none; margin-bottom: 22px" togglePosition="before" [disabled]="recipientOrganizationList.length === 0">
              <mat-expansion-panel-header style="padding-left: 2px; padding-right: 0" expandedHeight="48px" collapsedHeight="48px">
                <mat-panel-title>{{'RECIPIENT_ORGANIZATIONS' | translate}} ({{recipientOrganizationList.length}})</mat-panel-title>
              </mat-expansion-panel-header>
              <mat-list style="padding: 0">
                <div *ngFor="let organization of recipientOrganizationList; let i = index">
                  <mat-list-item>
                    <div matListItemTitle>{{organization.name}}</div>
                    <div matListItemMeta>
                      <button mat-icon-button (click)="removeRecipientOrganization(i)" class="delete-button">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </mat-list-item>
                  <mat-divider class="divider-position"></mat-divider>
                </div>
              </mat-list>
            </mat-expansion-panel>
          </form>
        </ng-template>
      </mat-step>

      <mat-step [stepControl]="thirdFormGroup" label="{{'ATTACHMENTS' | translate}} {{countAttachments()}}"
                [completed]="false">
        <ng-template matStepContent>
          <form [formGroup]="thirdFormGroup">
            <div>
              <p class="upload-title">{{'FILE_UPLOAD' | translate}}</p>
              <div class="dropzone"
                   [ngClass]="{ 'dragover': isDragOver }"
                   (drop)="onFileDrop($event)"
                   (dragover)="onDragOver($event)"
                   (dragleave)="onDragLeave($event)">
                <input type="file" id="fileDropRef" multiple
                       style="opacity: 0; position: relative; z-index: 2; width: 100%; height: 100%; top: 0; left: 0;"
                       (change)="uploadingFiles($event)">
                <p class="dropzone-text">{{'CHOOSE_A_FILE' | translate}}</p>
              </div>
              <mat-expansion-panel style="border: none; box-shadow: none; margin-bottom: 22px" togglePosition="before" expanded="true" [disabled]="uploadFileList.length === 0">
                <mat-expansion-panel-header style="padding-left: 2px; padding-right: 0" expandedHeight="48px" collapsedHeight="48px">
                  <mat-panel-title>{{'ATTACHMENTS' | translate}} ({{uploadFileList.length}})</mat-panel-title>
                </mat-expansion-panel-header>
<!--                <mat-list style="padding: 0">-->
<!--                  <div *ngFor="let file of uploadFileList; let i = index">-->
<!--                    <mat-list-item style="padding-left: 0" class="unset-list-item">-->
<!--                      <div matListItemTitle class="unset-title">{{file.content.name}}</div>-->
<!--                      <div matListItemLine>{{formatFileSize(file.content.size)}}</div>-->
<!--                      <div matListItemLine *ngIf="file.content.size > MAX_FILE_SIZE" style="color: #ED2447">{{'FILE_TOO_LARGE' | translate}}</div>-->
<!--                      <div matListItemMeta style="display: flex; flex-direction: row; align-items: center; justify-content: center; height: 100%" class="unset-meta-item">-->
<!--                        <mat-form-field subscriptSizing="dynamic" class="uploaded-file-type">-->
<!--                          <mat-select placeholder="{{'ATTACHMENT_TYPE' | translate}}" [(value)]="file.attachmentTypeCode" style="line-height: 2">-->
<!--                            <mat-option [value]="null">-->
<!--                              {{'NOT_SELECTED' | translate}}-->
<!--                            </mat-option>-->
<!--                            <mat-option *ngFor="let fileType of attachmentTypes" [value]="fileType.code">-->
<!--                              {{fileType.name}}-->
<!--                            </mat-option>-->
<!--                          </mat-select>-->
<!--                        </mat-form-field>-->
<!--                        <button mat-icon-button (click)="removeFile(i)" class="delete-button">-->
<!--                          <mat-icon>delete</mat-icon>-->
<!--                        </button>-->
<!--                      </div>-->
<!--                    </mat-list-item>-->
<!--                    <mat-divider class="divider-position"></mat-divider>-->
<!--                  </div>-->
<!--                </mat-list>-->
                <div *ngFor="let file of uploadFileList; let i = index" class="uploaded-file-div">
                  <div class="uploaded-file-inner-div">
                    <div class="uploaded-file-name"
                         [ngClass]="{'error-color': file.content.size > MAX_FILE_SIZE}">
                      {{file.content.name}}
                      <span class="uploaded-file-size"> ({{formatFileSize(file.content.size)}})</span>
                    </div>
                    <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-evenly">
                      <mat-form-field subscriptSizing="dynamic" class="uploaded-file-type">
                        <mat-select placeholder="{{'ATTACHMENT_TYPE' | translate}}" [(value)]="file.attachmentTypeCode">
                          <mat-option [value]="null">
                            {{'NOT_SELECTED' | translate}}
                          </mat-option>
                          <mat-option *ngFor="let fileType of attachmentTypes" [value]="fileType.code">
                            {{fileType.name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <button mat-icon-button class="error-color" (click)="removeFile(i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                  <mat-divider class="line-divider"></mat-divider>
                </div>
              </mat-expansion-panel>
            </div>
          </form>
        </ng-template>
      </mat-step>

      <mat-step [stepControl]="fourthFormGroup" label="{{'RELATED_DOCUMENTS' | translate}} {{countDocuments()}}" [completed]="false">
        <ng-template matStepContent>
          <form [formGroup]="fourthFormGroup">
            <div style="display: flex; flex-direction: column">

              <div style="display: flex; flex-flow: row wrap; align-items: center; column-gap: 24px">
                <div class="input-box">
                  <span class="input-field-label">{{'DOCUMENT' | translate}}</span>
                  <mat-form-field class="field-width field-bottom" subscriptSizing="dynamic">
                    <mat-icon matIconPrefix>search</mat-icon>
                    <input #inputDocument
                           type="text"
                           placeholder="{{'SEARCHING_FOR_DOCUMENT' | translate}}"
                           matInput
                           (input)="onSearchDocument(inputDocument.value)"
                           [formControl]="documentControl"
                           [matAutocomplete]="autoDocument">
                    <mat-autocomplete #autoDocument="matAutocomplete" [displayWith]="displayDocumentFn"

                                      (optionSelected)="selectDocument($event.option.value)">
                      <mat-option *ngIf="documentNotFound" disabled="true">{{'NO_RESULTS' | translate}}</mat-option>
                      <mat-option *ngFor="let document of filteredDocumentOptions | async" [value]="document">
                        {{document.identifier}}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-hint align="end">{{'EXAMPLE_SHORT' | translate}} 1-1/2025</mat-hint>
                  </mat-form-field>
                </div>
                <div class="mb-42">
                  <button mat-stroked-button [disabled]="!selectedDocument"
                          (click)="addDocument()">
                    {{'ADD' | translate}}
                  </button>
                </div>
              </div>

              <div style="display: flex; flex-flow: row wrap; align-items: center; column-gap: 24px">
                <div class="input-box">
                  <span class="input-field-label">{{'FOLDER' | translate}}</span>
                  <mat-form-field class="field-width field-bottom" subscriptSizing="dynamic">
                    <mat-icon matIconPrefix>search</mat-icon>
                    <input #inputFolder
                           type="text"
                           placeholder="{{'SEARCHING_FOR_FOLDER' | translate}}"
                           matInput
                           (input)="onSearchFolder(inputFolder.value)"
                           [formControl]="folderControl"
                           [matAutocomplete]="autoFolder">
                    <mat-autocomplete #autoFolder="matAutocomplete" [displayWith]="displayFolderFn"

                                      (optionSelected)="selectFolder($event.option.value)">
                      <mat-option *ngIf="folderNotFound" disabled="true">{{'NO_RESULTS' | translate}}</mat-option>
                      <mat-option *ngFor="let folder of filteredFolderOptions | async" [value]="folder">
                        {{folder.identifier}}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-hint align="end">{{'EXAMPLE_SHORT' | translate}} 1/2025</mat-hint>
                  </mat-form-field>
                </div>
                <div class="mb-42">
                  <button mat-stroked-button [disabled]="!selectedFolder"
                          (click)="addFolder()">
                    {{'ADD' | translate}}
                  </button>
                </div>
              </div>

            </div>
            <div>
              <mat-expansion-panel style="border: none; box-shadow: none; margin-bottom: 12px" togglePosition="before" [disabled]="documentList.length === 0">
                <mat-expansion-panel-header style="padding-left: 2px; padding-right: 0" expandedHeight="48px" collapsedHeight="48px">
                  <mat-panel-title>{{'RELATED_DOCUMENTS' | translate}} ({{documentList.length}})</mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list style="padding: 0">
                  <div *ngFor="let document of documentList; let i = index">
                    <mat-list-item>
                      <div matListItemTitle>{{document.identifier}}</div>
                      <div matListItemMeta>
                        <button mat-icon-button (click)="removeDocument(i)" class="delete-button">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </mat-list-item>
                    <mat-divider class="divider-position"></mat-divider>
                  </div>
                </mat-list>
              </mat-expansion-panel>
            </div>
            <div>
              <mat-expansion-panel style="border: none; box-shadow: none; margin-bottom: 22px" togglePosition="before" [disabled]="folderList.length === 0">
                <mat-expansion-panel-header style="padding-left: 2px; padding-right: 0" expandedHeight="48px" collapsedHeight="48px">
                  <mat-panel-title>{{'RELATED_FOLDERS' | translate}} ({{folderList.length}})</mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list style="padding: 0">
                  <div *ngFor="let folder of folderList; let i = index">
                    <mat-list-item >
                      <div matListItemTitle>{{folder.identifier}}</div>
                      <div matListItemMeta>
                        <button mat-icon-button (click)="removeFolder(i)" class="delete-button">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </mat-list-item>
                    <mat-divider class="divider-position"></mat-divider>
                  </div>
                </mat-list>
              </mat-expansion-panel>
            </div>
          </form>
        </ng-template>
      </mat-step>

    </mat-stepper>
  </div>

</mat-dialog-content>
<mat-dialog-actions style="display: flex; flex-direction: row; align-items: center;">
  <button mat-button [disabled]="stepper.selectedIndex === 0" (click)="stepper.previous()">
    {{'BACK' | translate}}
  </button>
  <button mat-button [disabled]="stepper.selectedIndex === stepper.steps.length - 1"(click)="stepper.next()">
    {{'NEXT' | translate}}
  </button>
  <span class="example-spacer"></span>
  <button mat-flat-button [disabled]="!isAllFormValid() || isUploading" (click)="createTask()">
    {{'CREATE' | translate}}
  </button>
</mat-dialog-actions>
